import { Button } from "@/shared/ui/button";
import { Tooltip } from "@/shared/ui/tooltip";
import type { FileActionButton } from "../../types";

interface FileActionsGridProps {
  actions: FileActionButton[];
  onActionClick: (actionLabel: string, actionOnClick?: () => void) => void;
}

export function FileActionsGrid({
  actions,
  onActionClick,
}: FileActionsGridProps) {
  const getActionHandler =
    (actionLabel: string, actionOnClick?: () => void) => () =>
      onActionClick(actionLabel, actionOnClick);

  return (
    <div className="flex items-center justify-center gap-2 border-t border-grid-200 px-6 py-4">
      {actions.map((action) => {
        const Icon = action.icon;
        return (
          <Tooltip key={action.label} content={action.label}>
            <Button
              variant="ghost"
              size="icon"
              className={action.className || "h-10 w-10"}
              aria-label={action.label}
              onClick={getActionHandler(action.label, action.onClick)}
              disabled={action.disabled}
            >
              <Icon className="h-5 w-5" />
            </Button>
          </Tooltip>
        );
      })}
    </div>
  );
}
